import { useEffect, useState } from 'react'
import type { ListField } from '@ztechapps/common.hook'
import { useTableContext } from '../Context'
import { MIN_COLUMN_WIDTH, useColumnResizeDrag } from '../../hooks/useColumnResizeDrag'

export const useColumResize = (field: ListField) => {
  const { setFields } = useTableContext()
  const fieldKey = field?.key
  const fieldSize = field?.size ?? MIN_COLUMN_WIDTH
  // Initial widths for each column
  const [width, setWidth] = useState<number>(fieldSize)

  useEffect(() => {
    setWidth(fieldSize)
  }, [fieldSize])

  const { onStart } = useColumnResizeDrag({
    width,
    onDrag: setWidth,
    onResize: (size) => setFields({ [fieldKey]: { size } }),
  })

  return { onStart, width }
}
